export const reduxKey = '@@groupGallectionSelector';
